package com.essntl.uikit.components.chat.message

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import core.dateformat.utils.formatTimestamptzToHHMM
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsMediumIcon
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun Sender(
    message: MessageUiState,
    senderName: String?,
    modifier: Modifier = Modifier,
) {
    val uriHandler = LocalUriHandler.current

    Column(
        horizontalAlignment = Alignment.End,
    ) {
        Box(modifier = Modifier.fillMaxWidth(0.7f)) {
            Box(modifier = Modifier.fillMaxWidth()) {
                Column(
                    modifier = modifier
                        .padding(bottom = if (message.reactions.any { it.emoji != null }) 28.dp else 0.dp)
                        .background(
                            color = MaterialTheme.esColorScheme.bgContrast,
                            shape = RoundedCornerShape(topEnd = 12.dp, topStart = 12.dp, bottomStart = 12.dp),
                        ).padding(10.dp)
                        .align(Alignment.CenterEnd)
                        .pointerHoverIcon(
                            if (message.linkPreview != null)
                                PointerIcon.Hand else
                                PointerIcon.Default,
                        )
                        .clickable(
                            enabled = message.linkPreview != null,
                        ) {
                            message.linkPreview?.let {
                                uriHandler.openUri(
                                    uri = it.url,
                                )
                            }
                        },
                ) {
                    Text(
                        text = if (message.linkPreview != null)
                            message.linkPreview.body else
                            message.text,
                        color = MaterialTheme.esColorScheme.textContrast,
                    )

                    Spacer(modifier = Modifier.height(1.spacing))

                    Row(
                        horizontalArrangement = Arrangement.End,
                        verticalAlignment = Alignment.Bottom,
                        modifier = Modifier.align(Alignment.End),
                    ) {
                        Text(
                            text = formatTimestamptzToHHMM(message.dateTime),
                            color = MaterialTheme.esColorScheme.textDisabled,
                            style = MaterialTheme.esTypography.c1Medium11,
                            textAlign = TextAlign.End,
                        )

                        Spacer(modifier = Modifier.width(.3.spacing))

                        EsMediumIcon(
                            res = if (message.status == MessageUiState.Status.Pending) EsIcons.Tick else
                                EsIcons.DoubleTick,
                            tint = if (message.status == MessageUiState.Status.Read) Color.Green else
                                MaterialTheme.esColorScheme.iconDisabled,
                        )
                    }
                }
            }

            if (message.reactions.any { it.emoji != null })
                EsMessageReaction(
                    message = message,
                    modifier = Modifier
                        .padding(end = 10.dp)
                        .background(
                            color = MaterialTheme.esColorScheme.bgContrast,
                            shape = RoundedCornerShape(20.dp),
                        )
                        .align(Alignment.BottomEnd),
                )
        }

        if (senderName != null) {
            Spacer(modifier = Modifier.width(1.spacing))

            Text(
                text = senderName,
                color = Color(0xFF6F6A8A),
                style = MaterialTheme.esTypography.c1Medium11,
                textAlign = TextAlign.End,
            )
        }
    }
}